<template>
  <tr :class="rowClass">
    <td>
      <RenderMathQuestion
        :question-kind="question.questionKind || 'text'"
        :question="question.question || ''"
      />
    </td>
    <td class="tw-text-center">
      <RenderMathAnswer
        :answer="question.answer?.value || ''"
        :answer-render-kind="question.answerRender?.kind"
        :answer-render="question.answerRender?.render?.answer"
        :question="question"
        :formats="answerFormats"
      />
    </td>
    <td class="tw-text-center">
      <span v-if="!question.answer?.isCorrect && question.answer">
        <RenderMathAnswer
          :answer="question.expectedAnswer || ''"
          :answer-render-kind="question.answerRender?.kind"
          :answer-render="question.answerRender?.render?.correct"
          :question="question"
        />
      </span>
    </td>
  </tr>
</template>

<style scoped lang="postcss">
th,
td {
  @apply tw-py-2 tw-px-4;
}
.red {
  @apply tw-text-red-600;
}
.grey {
  @apply tw-text-gray-400;
}
</style>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Dict } from "@/types/generalTypes";
import { SfMathTestQuestion } from "@/types/mathsTypes";
import RenderMathAnswer from "../shared/RenderMathAnswer.vue";
import RenderMathQuestion from "../shared/RenderMathQuestion.vue";

export default defineComponent({
  components: { RenderMathQuestion, RenderMathAnswer },
  props: {
    question: { type: Object as PropType<SfMathTestQuestion>, required: true },
  },
  computed: {
    rowClass() {
      if (!this.question.answer) {
        return "grey";
      }
      if (!this.question.answer?.isCorrect) {
        return "red";
      }
      return "";
    },
    answerFormats() {
      const res = {} as Dict<any>;
      if (Array.isArray(this.question.expectedAnswer)) {
        for (const a of this.question.expectedAnswer) {
          res[a.name] = a.fullFormat;
        }
      }
      return res;
    },
  },
});
</script>
